module.exports = __webpack_public_path__ + "static/img/4.0580dd9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/13/eng/4.png
// module id = XH1V
// module chunks = 0